import React from 'react';
import Input from '../../components/atoms/Input/Input';
import Button from '../../components/atoms/Button/Button';
import { EmailOutlined, LockOutlined } from '@mui/icons-material';
import logo from '../../assets/images/logo.png';
import bgDa from '../../assets/images/login-bg.jpg';
import './LoginTemplate.css';

const LoginTemplate = ({ 
  credentials, 
  onChangeHandler, 
  onSubmitHandler, 
  errorMessage, 
  isLoading 
}) => {
  return (
    <div className="login-template">
      {/* Left Side - Image */}
      <div className="login-left">
        <div className="left-overlay"></div>
        <img src={bgDa} alt="Background" className="bg-image" />
        <div className="left-content">
          <img src={logo} alt="SecuFire Action" className="left-logo" />
          <h1 className="left-title">Bienvenue sur le Dashboard Admin</h1>
          <p className="left-description">
            Accès à l’interface d’administration SecuFire Action
          </p>
          <div className="dots-indicator">
            <span className="dot active"></span>
            <span className="dot"></span>
            <span className="dot"></span>
          </div>
        </div>
      </div>

      {/* Right Side - Form */}
      <div className="login-right">
        <div className="login-form-container">
          <div className="form-header">
            <h2 className="form-title">Page de connexion</h2>
            {/* <p className="form-subtitle">Comment puis-je commencer avec SecuFire ?</p> */}
          </div>

          <form className="login-form" onSubmit={onSubmitHandler}>
            {errorMessage && (
              <div className="error-message">
                <span className="error-icon">⚠️</span>
                {errorMessage}
              </div>
            )}

            <div className="form-group">
              <label className="form-label">Email</label>
              <Input
                type="email"
                name="email"
                placeholder="Entrer l'adresse email"
                value={credentials.email}
                onChangeHandler={onChangeHandler}
                icon={<EmailOutlined />}
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">Mot de passe</label>
              <Input
                type="password"
                name="password"
                placeholder="Entrer le mot de passe"
                value={credentials.password}
                onChangeHandler={onChangeHandler}
                icon={<LockOutlined />}
                required
              />
            </div>

            {/* <div className="form-options">
              <label className="remember-checkbox">
                <input type="checkbox" />
                <span>Se souvenir de moi</span>
              </label>
              <a href="#forgot" className="forgot-link">Mot de passe oublié ?</a>
            </div> */}

            <Button 
              type="submit" 
              variant="primary" 
              disabled={isLoading}
              fullWidth
              label={isLoading ? 'Connexion...' : 'Se connecter'}
            />
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginTemplate;